export enum SObject {
  AttributeSet = 'SBQQ__AttributeSet__c',
  CustomAction = 'SBQQ__CustomAction__c',
  ConfigurationAttribute = 'SBQQ__ConfigurationAttribute__c',
  ConfigurationRule = 'SBQQ__ConfigurationRule__c',
  CustomActionCondition = 'SBQQ__CustomActionCondition__c',
  ErrorCondition = 'SBQQ__ErrorCondition__c',
  LineColumn = 'SBQQ__LineColumn__c',
  Localization = 'SBQQ__Localization__c',
  LookupData = 'SBQQ__LookupData__c',
  LookupQuery = 'SBQQ__LookupQuery__c',
  OptionConstraint = 'SBQQ__OptionConstraint__c',
  ProductAction = 'SBQQ__ProductAction__c',
  PriceAction = 'SBQQ__PriceAction__c',
  PriceRule = 'SBQQ__PriceRule__c',
  PriceCondition = 'SBQQ__PriceCondition__c',
  Product = 'Product2',
  ProductAttribute = 'SBQQ__ProductAttribute__c',
  ProductAttributeSet = 'SBQQ__ProductAttributeSet__c',
  ProductOption = 'SBQQ__ProductOption__c',
  ProductFeature = 'SBQQ__ProductFeature__c',
  ProductRule = 'SBQQ__ProductRule__c',
  QuoteTemplate = 'SBQQ__QuoteTemplate__c',
  QuoteTerm = 'SBQQ__QuoteTerm__c',
  TermCondition = 'SBQQ__TermCondition__c',
  SearchFilters = 'SBQQ__SearchFilter__c',
  SummaryVariable = 'SBQQ__SummaryVariable__c',
  TemplateContent = 'SBQQ__TemplateContent__c',
  TemplateSection = 'SBQQ__TemplateSection__c',
  BlockPrice = 'SBQQ__BlockPrice__c',
  Cost = 'SBQQ__Cost__c',
  PriceDimension = 'SBQQ__Dimension__c',
  PricebookEntry = 'PricebookEntry',
  Pricebook = 'Pricebook2',
  CustomScript = 'SBQQ__CustomScript__c',
  SearchFilter = 'SBQQ__SearchFilter__c',
  DiscountCategory = 'SBQQ__DiscountCategory__c',
  DiscountSchedule = 'SBQQ__DiscountSchedule__c',
  DiscountTier = 'SBQQ__DiscountTier__c',
  // Advanced Approvals
  ApprovalRule = 'sbaa__ApprovalRule__c',
  Approver = 'sbaa__Approver__c',
  ApprovalVariable = 'sbaa__ApprovalVariable__c',
  EmailTemplate = 'sbaa__EmailTemplate__c',
  ApprovalChain = 'sbaa__ApprovalChain__c',
  ApprovalCondition = 'sbaa__ApprovalCondition__c',
  TrackedField = 'sbaa__TrackedField__c',
  // Billing
  GLAccount = 'blng__GLAccount__c',
  GLRule = 'blng__GLRule__c',
  GLTreatment = 'blng__GLTreatment__c',
  LegalEntity = 'blng__LegalEntity__c',
  TaxRule = 'blng__TaxRule__c',
  TaxIntegration = 'blng__TaxIntegration__c',
  TaxTreatment = 'blng__TaxTreatment__c',
  RevenueDistributionMethod = 'blng__RevenueDistributionMethod__c',
  RevenueRecognitionRule = 'blng__RevenueRecognitionRule__c',
  RevenueRecognitionTreatement = 'blng__RevenueRecognitionTreatment__c',
  FinanceBook = 'blng__FinanceBook__c',
  FinancePeriod = 'blng__FinancePeriod__c',
  PaymentGateway = 'blng__PaymentGateway__c',
  PaymentScheduler = 'blng__PaymentScheduler__c',
  BillingRule = 'blng__BillingRule__c',
  BillingTreatment = 'blng__BillingTreatment__c',
  InvoicePlan = 'blng__InvoicePlan__c',
  InvoiceScheduler = 'blng__InvoiceScheduler__c',
}
